import { toast } from "react-toastify";

// FIREBASE
import { getFirebase } from "react-redux-firebase";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { getAuth } from "firebase/auth";
import { isSignInWithEmailLink, parseActionCodeURL, signInWithEmailLink, sendSignInLinkToEmail, setPersistence, browserSessionPersistence } from "firebase/auth";
import { doc, getDoc, getDocs, setDoc, collection, updateDoc, query, where } from "firebase/firestore";
import { ToastWarn } from "../../commonComponents/ToastHelper";
import { update } from "firebase/database";

import { db_firestore, auth } from "../../firebase/config.js";
import { current } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import firebase from "../../firebase/config";

async function getUserTenantId(creds) {
  try {
    // database object
    const firestore = getFirebase().firestore();
    // query
    var query = firestore.collection("users").where(`user_info.email`, "==", creds.emailAddress);
    let tenant_id;
    await query.get().then((querySnapshot) => {
      tenant_id = querySnapshot.docs[0].data().organization_info.tenant_id;
    });
    return tenant_id;
  } catch (e) {
    console.error(new Error("can't get user tenant."), e);
  }
}

// SEND EMAIL LINK
async function sendSignInLinkEmailFn(auth, creds, actionCodeSettings, signInPersistence, tenant_id) {
  if (signInPersistence) {
    // DOC : https://firebase.google.com/docs/auth/web/auth-state-persistence
    setPersistence(auth, browserSessionPersistence)
      .then(async () => {
        // return sendSignInLinkToEmail(auth, creds.emailAddress, actionCodeSettings).then(() => {
        //   // The link was successfully sent. Inform the user.
        //   // Save the email locally so you don't need to ask the user for it again
        //   // if they open the link on the same device.
        //   console.log("signIn with persistence successfuly: ", signInPersistence);
        //   window.localStorage.setItem("emailForSignIn", creds.emailAddress);
        // });
        actionCodeSettings["tenantId"] = tenant_id;

        console.log("[sendSignInLinkEmailFn]", tenant_id, actionCodeSettings, creds.emailAddress);
        let url;
        if (process.env.REACT_APP_NODE_ENV === "DEV") {
          firebase.functions().useFunctionsEmulator("http://localhost:5001");
          url = "http://localhost:5001/lokalite-saas/us-central1/app/siginWithEmailLink";
        } else {
          url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/siginWithEmailLink";
        }
        await fetch(
          `${url}?user_email=${encodeURIComponent(creds.emailAddress)}&actionCodeSettings=${encodeURIComponent(JSON.stringify(actionCodeSettings))}&tenant_id=${encodeURIComponent(tenant_id)}`
        )
          // console.log("resooo", await reponse.json())
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            console.log("[sendSignInLinkEmailFn - DONE]: ", json);
            // dispatch({ type: "CREATE_ANALYSIS", payload: json });
          });
      })

      .catch((error) => {
        console.Error("can't send signin link to email with persistence:", error);
        // Handle / display error.
        // ...
      });
  } else {
    // DOC : https://firebase.google.com/docs/auth/admin/email-action-links
    actionCodeSettings["tenantId"] = tenant_id;
    sendSignInLinkToEmail(auth, creds.emailAddress, actionCodeSettings)
      .then(() => {
        // The link was successfully sent. Inform the user.
        // Save the email locally so you don't need to ask the user for it again
        // if they open the link on the same device.
        window.localStorage.setItem("emailForSignIn", creds.emailAddress);
      })
      .catch((error) => {
        console.Error("can't send signin link to email wuthout persistence:", error);
        // Handle / display error.
        // ...
      });
  }
}
export const sendSignInLinkEmail = (items) => {
  return async (dispatch, getState, { getFirebase }) => {
    // check if user email exists
    // await db_firestore
    //   .collection("users")
    //   .where("user_info.email", "==", items.creds.emailAddress)
    //   .get()
    //   .then((userSnapshort) => {
    //     user_exists = !userSnapshort.empty;
    //   });
    let url;
    if (process.env.REACT_APP_NODE_ENV === "DEV") {
      firebase.functions().useFunctionsEmulator("http://localhost:5001");
      url = "http://localhost:5001/lokalite-saas/us-central1/app/getUserByEmail";
    } else {
      url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/getUserByEmail";
    }
    let user_exists;
    await fetch(`${url}?user_email=${encodeURIComponent(items.creds.emailAddress)}`)
      // console.log("response", await response.json())
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log("[getUserByEmail - DONE]: ", json);
        user_exists = json.data.user_exsits;
        // dispatch({ type: "CREATE_ANALYSIS", payload: json });
      });

    if (user_exists) {
      // get user tenant
      const tenant_id = await getUserTenantId(items.creds);
      // set auth object
      const auth = getAuth();
      // set user tenant
      auth.tenantId = tenant_id;

      let url;
      if (process.env.REACT_APP_NODE_ENV === "DEV") {
        url = "http://localhost:3000/Home";
      } else {
        url = "https://lokalite-saas.web.app/Home";
      }

      // console.log("sendSignInLinkEmail_tenant_id", tenant_id);
      const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for
        // this URL must be whitelisted in the Firebase Console.
        url: url,
        // This must be true for email link sign-in.
        handleCodeInApp: true,
        // FDL custom domain.
        dynamicLinkDomain: "lokalitesaas.page.link",
        tenantId: tenant_id,
      };

      console.log("**** Sending Email Link");
      // TODO handle other errors
      await sendSignInLinkEmailFn(auth, items.creds, actionCodeSettings, items.signInPersistence, tenant_id)
        .then(() => {
          dispatch({ type: "SEND_SIGN_IN_EMAIL_LINK" });
          items.navigate("/SigninConfirmation");
        })
        .catch((e) => {
          console.log("error", e);
          // dispatch({ type: "SIGN_IN_ERR" }, e)
        });
    } else {
      ToastWarn("Adresse email introuvable.");
    }
  };
};

// SIGNIN WITH EMAIL LINK
async function signInWithEmailLinkFn(navigate) {
  // const auth = getAuth();

  if (isSignInWithEmailLink(auth, window.location.href)) {
    const actionCodeUrl = parseActionCodeURL(window.location.href);
    if (actionCodeUrl.tenantId) {
      auth.tenantId = actionCodeUrl.tenantId;
    }
    // Additional state parameters can also be passed via URL.
    // This can be used to continue the user's intended action before triggering
    // the sign-in operation.
    // Get the email if available. This should be available if the user completes
    // the flow on the same device where they started it.
    let email = window.localStorage.getItem("emailForSignIn");
    if (!email) {
      do {
        // User opened the link on a different device. To prevent session fixation
        // attacks, ask the user to provide the associated email again. For example:
        email = window.prompt("Votre navigateur est sécurisé. Veuillez founir votre adresse email à nouveau pour confirmation.");
      } while (email == null || email == "");
    }

    console.log(auth, email, window.location.href);
    // The client SDK will parse the code from the link for you.
    await signInWithEmailLink(auth, email, window.location.href)
      .then((result) => {
        // User is signed in.
        // tenant ID available in result.user.tenantId.
        // Clear email from storage. ??
        window.localStorage.removeItem("emailForSignIn");
      })
      .catch((e) => {
        console.log("signInWithEmailLink - ERROR: ", e);
        if (e.code === "auth/invalid-action-code") {
          // navigate("/WrongEmailSignin");
          console.log("signInWithEmailLink - auth/invalid-action-code");
        } else if (e.code === "auth/invalid-email") {
          email = window.prompt("Votre navigateur est sécurisé. Veuillez founir votre adresse email à nouveau pour confirmation.");
        }
      });
  }
}
export const signInWithEmailLink_ = (navigate) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SIGN_IN_WITH_EMAIL_LINK]");
    await signInWithEmailLinkFn(navigate)
      .then(() => {
        console.log("[SIGN_IN_WITH_EMAIL_LINK] - DONE:", getFirebase().auth().currentUser);
        dispatch({ type: "SIGN_IN_WITH_EMAIL_LINK" });
      })
      .catch((e) => {
        console.log("[SIGN_IN_WITH_EMAIL_LINK] - ERROR:", e);
        // dispatch({ type: "SIGN_IN_ERR" }, e)
      });
  };
};

export const sendPasswordResetLink = (items) => {
  return async (dispatch, getState, { getFirebase }) => {
    const auth = getFirebase().auth();
    auth
      .sendPasswordResetEmail(items.emailAddress)
      .then(() => {
        // Construct password reset email template, embed the link and send
        // using custom SMTP server.
        console.log("reset password email sent succesfully.");
        // return sendCustomPasswordResetEmail(userEmail, displayName, link);
        dispatch({ type: "SEND_PASSWORD_REST_LINK" });
        items.navigate("/ForgotPasswordConfirmationPage");
      })
      .catch((error) => {
        // Some error occurred.
        console.error("ERROR", error);
        ToastWarn("Adresse email introuvable.");
        // toast.warn(
        //   <div className="flex justify-between items-center">
        //     <p>Adresse email introuvable.</p>
        //   </div>
        //   , { position: "bottom-center", });
      });
  };
};

// export const setCguOk = () => {
//   return async (dispatch, getState, { getFirebase }) => {
//     try {
//       console.log("[SET_CGU_OK] - START");
//       const userRef = doc(db_firestore, "users", auth.currentUser.uid);
//       // const docSnap = await getDoc(userRef);

//       // const user_data = docSnap.data();

//       console.log("[SET_CGU_OK] - USERREF", userRef);

//       // user_data["usage_info"]["cgu_accepted"] = true;
//       // update remote
//       await updateDoc(userRef, {
//         "usage_info.cgu_accepted": true,
//         // ["usage_info.cgu_accepted"]: user_data["usage_info"],
//       });

//       dispatch({ type: "SET_CGU_OK" });
//     } catch (e) {
//       console.error(new Error("can't setCguOk."), e);
//     }
//   };
// };

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    console.log("[LOGOUT]");
    // clear redux persist storage
    // clearStore();

    const firebase = getFirebase();
    firebase
      .auth()
      .signOut()
      .then(() => {
        console.log("[LOGOUT] - DONE.");
        dispatch({ type: "LOGOUT" });
      });
  };
};

export const signUp = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .createUserWithEmailAndPassword(creds.email, creds.password)
      .then(() => {
        dispatch({ type: "SIGN_UP" });
      })
      .catch((err) => {
        dispatch({ type: "SIGN_UP_ERR" }, err);
      });
  };
};

export const clearStore = () => {
  return (dispatch, getState, { getFirebase }) => {
    console.log("[CLEAR_STORE] - DONE");
    dispatch({ type: "CLEAR_STORE" });
  };
};

// async function signInUserWithEmailAndPasswordInTenant(creds) {
//   try {
//     // get user tenant
//     const tenant_id = await getUserTenantId(creds)
//     // set auth object
//     const auth = getAuth();
//     // set user tenant
//     auth.tenantId = tenant_id;
//     // auth user in tenant
//     signInWithEmailAndPassword(auth, creds.emailAddress, creds.password)
//       .then((userCredential) => {
//         // setEmailErrorMsg('')
//         console.log("signin user successfully.", userCredential)
//       }).catch((e) => {
//         switch (e.code) {
//           case 'auth/wrong-password':
//             // setEmailErrorMsg('Mot de passe incorrecte.')
//             toast.warn(
//               <div className="flex justify-between items-center">
//                 <p>Mot de passe incorrecte.</p>
//               </div>
//             );
//             console.error("error signin user. Wrong password", e.code)
//             return;
//           default:
//             console.error(e.code);
//         }
//       })
//     return auth
//   } catch {
//     console.log("can't sign in user in tenant.")
//   }
// }
